import Enumeration from '@enums/enum';
import { isNil } from 'lodash';
import { i18n } from '@src/i18n-setup';
import getDateString from '@utils/date/get-date-string';

export const FieldsEnum = new Enumeration({
  EMPTY: '-',
});

/**
 * Returns the field if it is available
 * If not, returns default value
 *
 * @param {String} translation
 * @param {String} field
 */
export default function getField(field) {
  if (isNil(field)) {
    return FieldsEnum.EMPTY;
  }

  return field;
}

/**
 * Returns the field translation if it is available
 * If not, returns default value
 *
 * @param {String} translation
 * @param {String} field
 */
export function getFieldString(translation, field) {
  if (isNil(field)) {
    return FieldsEnum.EMPTY;
  }

  return i18n.t(translation);
}

/**
 * Returns the field formatted, if it is available
 * If not, returns default value
 *
 * @param {String} field
 */
export function getFieldCurrency(field) {
  if (isNil(field)) {
    return FieldsEnum.EMPTY;
  }

  return i18n.n(field, 'currency');
}

/**
 * Returns the field formatted, if it is available
 * If not, returns default value
 *
 * @param {String} field
 */
export function getFieldDecimal(field) {
  if (isNil(field)) {
    return FieldsEnum.EMPTY;
  }

  return i18n.n(field, 'decimal');
}

/**
* Returns the field formatted, if it is available
 * If not, returns default value
 *
 * @param {String} field
 */
export function getFieldPercent(field) {
  if (isNil(field)) {
    return FieldsEnum.EMPTY;
  }

  return `${field}%`;
}

/**
* Returns the field formatted, if it is available
 * If not, returns default value
 *
 * @param {String} field
 */
export function getFieldDate(field) {
  if (isNil(field)) {
    return FieldsEnum.EMPTY;
  }

  return getDateString(field);
}

/**
 * Gets the rate type value for the offer. May be fixed with years or variable.
 * @private
 * @param {Object} The offer.
 * @return {String} The translated value to display.
 */
export function getFieldCategory(organisation) {
  if (isNil(organisation) || isNil(organisation.category)) {
    return FieldsEnum.EMPTY;
  }

  return i18n.t(`common.lender_category.${organisation.category.replace(/ /gi, '_')}`);
}
